import { Card, Image, Timeline, Typography } from "antd";
import "./styles.less";

const { Paragraph } = Typography;

const ProjectOnGoingTabExecution = () => {
  return (
    <Timeline className="project-on-going-tab-execution">
      <Timeline.Item>
        <Card title="12 Octobre 2025" className="image-preview-group">
          <Paragraph type="secondary">Clôture du projet</Paragraph>
          <Image.PreviewGroup>
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/10/30/20251030103855-b342be27-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/10/30/20251030103854-bc070e8a-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/10/30/20251030103853-9e5c2c4e-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/10/30/20251030103852-5db9d89d-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/10/30/20251030103851-f4b431e3-me.jpg" />
          </Image.PreviewGroup>
        </Card>
      </Timeline.Item>
      <Timeline.Item>
        <Card title="27 Septembre 2025" className="image-preview-group">
          <Paragraph type="secondary">Liaison avec le biodigesteur</Paragraph>
          <Image.PreviewGroup>
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/27/20250927231302-52524ed0-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/27/20250927231302-a0572a56-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/27/20250927231303-96cb0377-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/27/20250927231303-f9f1f1a0-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/27/20250927231301-f8b54ee3-me.jpg" />
          </Image.PreviewGroup>
        </Card>
      </Timeline.Item>
      <Timeline.Item>
        <Card title="07 Septembre 2025" className="image-preview-group">
          <Paragraph type="secondary">Construction du biodigesteur</Paragraph>
          <Image.PreviewGroup>
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/08/20250908120916-24d2c598-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/08/20250908120917-06547e2e-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/08/20250908120917-5120aac2-me.jpg" />
          </Image.PreviewGroup>
        </Card>
      </Timeline.Item>
      <Timeline.Item>
        <Card title="05 Septembre 2025" className="image-preview-group">
          <Paragraph type="secondary">Construction du biodigesteur</Paragraph>
          <Image.PreviewGroup>
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/06/20250906065906-3f1de929-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/06/20250906065907-8857c8fc-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/06/20250906065907-5925418d-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/06/20250906065907-7c055ed9-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/06/20250906065908-d462508e-me.jpg" />
          </Image.PreviewGroup>
        </Card>
      </Timeline.Item>
      <Timeline.Item>
        <Card title="04 Septembre 2025" className="image-preview-group">
          <Paragraph type="secondary">Construction du biodigesteur</Paragraph>
          <Image.PreviewGroup>
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/04/20250904170809-7cd3f01c-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/04/20250904170809-8cff9670-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/04/20250904170808-5452e884-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/04/20250904170807-3507fe34-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/04/20250904170806-2b619242-me.jpg" />
          </Image.PreviewGroup>
        </Card>
      </Timeline.Item>
      <Timeline.Item>
        <Card title="02 Septembre 2025" className="image-preview-group">
          <Paragraph type="secondary">Fabrication de parpaings</Paragraph>
          <Image.PreviewGroup>
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/02/20250902201626-133d2fea-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/02/20250902201627-8df31004-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/09/02/20250902201628-fee3afdf-me.jpg" />
          </Image.PreviewGroup>
        </Card>
      </Timeline.Item>
      <Timeline.Item>
        <Card title="30 Août 2025" className="image-preview-group">
          <Paragraph type="secondary">Livraison de sable</Paragraph>
          <Image
            src="https://piwigo.ataajy.lu/_data/i/upload/2025/08/31/20250831071617-51fea89d-me.jpg"
            alt="Livraison de sable"
          />
          <Paragraph type="secondary" className="space-top">
            Livraison du fer
          </Paragraph>
          <Image.PreviewGroup>
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/08/31/20250831071353-82585437-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/08/31/20250831071353-79fa48f1-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/08/31/20250831071352-224dc31b-me.jpg" />
          </Image.PreviewGroup>
          <Paragraph type="secondary" className="space-top">
            Lieu de contruction du biodigesteur
          </Paragraph>
          <Image.PreviewGroup>
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/08/31/20250831071353-d516db84-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/08/31/20250831071352-79c69d97-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/08/31/20250831071351-6c4bc640-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/08/31/20250831071351-c628f1f1-me.jpg" />
            <Image src="https://piwigo.ataajy.lu/_data/i/upload/2025/08/31/20250831071350-ff577433-me.jpg" />
          </Image.PreviewGroup>
        </Card>
      </Timeline.Item>
    </Timeline>
  );
};

export default ProjectOnGoingTabExecution;
